import React, { useEffect, useRef, useState } from "react";
import { Col, Row, Form } from "react-bootstrap";
import Moment from "react-moment";
import API from '../../Utility';

export default function Task({
  project,
  workflow,
  workflowUser,
  milestoneIndex,
  taskIndex,
  milestone,
  task,
  setWorkflowUserStatus,
}) {
  const [checkboxStatus, setCheckboxStatus] = useState(null);
  const [checkboxLoading, setCheckboxLoading] = useState(null);

  const completeTask = (user, task, userWorkflowTasksId, milestoneId, milestoneIndex, taskIndex, toggleStatus) => {
    setCheckboxLoading('loading');
    setCheckboxStatus(toggleStatus);
    const onCompleteTaskSuccess = (status, progressInfo) => {
      setCheckboxStatus(status);
      setCheckboxLoading('done');
      if (progressInfo?.status) {
        setWorkflowUserStatus(progressInfo?.status);
      }
    };
    const callApi = async function() {
      try {
        const apiCallConfig = {
          url: `/admin/${project}/workflows/${workflow._id}/completeTask`,
        };
        apiCallConfig.data = {
          user: user._id,
          workflow: { _id: workflow._id },
          task: task._id
        };
        const res = await API.post(apiCallConfig);
        if (res.completed || res.uncompleted) {
          onCompleteTaskSuccess(res.completed ? true : false, res?.progressInfo);
        } else {
          throw new Error(res);
        }
      } catch (err) {
        console.error(err);
      }
    };
    callApi();
  };

  const getRoleName = (role) => {
    let roleIndex = workflow.assigneeRoles.findIndex((aRole) => aRole._id === role);
    if (roleIndex > -1) {
      return workflow.assigneeRoles[roleIndex].name;
    } else {
      return '';
    }
  };

  const getRoleUsers = (userWorkflow, role) => {
    let users = [];
    userWorkflow?.assignees?.map((assignee) => {
      if (assignee?.assigneeRole?._id === role) {
        users.push(assignee?.user?.displayName);
        return assignee?.user?.displayName;
      } else {
        return '';
      }
    });
    return users.join(', ');
  };

  return (
    <Row key={`${milestoneIndex}-${taskIndex}`} className='task-row' style={{ borderBottom: taskIndex === milestone?.tasks?.filter(task => task.type !== 'message')?.length - 1 ? 'none' :  '1px solid #ccc', padding: '20px 0 10px 0' }}>
      <Col sm={12}>
        <Row style={{ width: '100%', marginBottom: '20px' }}>
          <Col sm={5}>
            <Form as={Row} style={{ flexWrap: 'nowrap' }}>
              <Form.Control
                className='clickable'
                disabled={checkboxLoading === 'loading'}
                checked={checkboxStatus === false ? false : checkboxStatus || task.isCompleted === true}
                style={{ minWidth: '30px', minHeight: '30px', maxWidth: '30px', maxHeight: '30px', marginRight: '20px', marginTop: '-2px' }}
                type="checkbox"
                name={`task${task._id}Checkbox`}
                onChange={(e) => {
                  completeTask(workflowUser.user, task, workflowUser._id, milestone._id, milestoneIndex, taskIndex, e.target.checked);
                }}
              />
              <Form.Label>{task.name}</Form.Label>
            </Form>
          </Col>
          <Col sm={5}>
            {task.type === 'message' ? '-' : (task.userCanComplete ? 'User' : task.assigneeRoles?.map((role, roleIndex) => {
              return (
                <div key={roleIndex}>
                  {getRoleName(role)}: {getRoleUsers(workflowUser,role)}
                </div>
              );
            }))}
          </Col>
          <Col sm={2} style={{ textAlign: 'right' }}>
                                                    Due: <Moment format="DD MMM 'YY" add={{ days: task?.endDay - 1 }}>{workflowUser.startDate}</Moment>
          </Col>
        </Row>
        <Row style={{ width: '100%', marginBottom: task?.taskData?.assets?.length > 0 ? '20px' : '10px' }}>
          <Col sm={5}>
            <div style={{ textAlign: 'justify', paddingLeft: '35px', paddingRight: '20px' }} dangerouslySetInnerHTML={{ __html: task.details }} />
          </Col>
          <Col sm={7}>
            <div style={{ textAlign: 'justify' }} dangerouslySetInnerHTML={{ __html: task.instructions }} />
          </Col>
        </Row>
        {task?.taskData?.assets?.length > 0 && (
          <Row style={{ width: '100%', padding: '10px 0 0 0', marginBottom: '10px' }}>
            <Col>
              <div style={{ paddingLeft: '35px' }}>
                {task.taskData.assets.map((upload, uploadIndex) => {
                  return (
                    <span key={uploadIndex} style={{ marginRight: '5px' }}>
                      <a href={upload.path} target='_blank' rel='noreferrer'>
                        {upload.name}
                      </a>
                      {uploadIndex < task.taskData.assets.length - 1 && ', '}
                    </span>
                  );
                })}
              </div>
            </Col>
          </Row>
        )}
        {task?.userTaskData?.[0]?.assets?.length > 0 && (
          <Row style={{ width: '100%', padding: '10px 0 0 0', marginBottom: '10px' }}>
            <Col>
              <div style={{ paddingLeft: '35px' }}>
                {task.userTaskData?.[0].assets.map((upload, uploadIndex) => {
                  return (
                    <span key={uploadIndex} style={{ marginRight: '5px' }}>
                      <a href={upload.path} target='_blank' rel='noreferrer'>
                        {upload.name}
                      </a>
                      {uploadIndex < task.userTaskData?.[0].assets.length - 1 && ', '}
                    </span>
                  );
                })}
              </div>
            </Col>
          </Row>
        )}
      </Col>
    </Row>
  );
}